(function () {
  function initFaqSection(section) {
    section.querySelectorAll('.faq-item__trigger').forEach((trigger) => {
      if (trigger.dataset.faqBound === 'true') return;
      trigger.dataset.faqBound = 'true';

      trigger.addEventListener('click', () => {
        const item = trigger.closest('.faq-item');
        const isOpen = item.classList.contains('is-open');

        item.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));

        const panel = item.querySelector('.faq-item__panel');
        if (!isOpen) {
          panel.style.height = panel.scrollHeight + 'px';
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(() => {
            panel.style.height = '0px';
          });
        }
      });
    });

    const preOpen = section.querySelector('.faq-item.is-open .faq-item__panel');
    if (preOpen) {
      preOpen.style.height = preOpen.scrollHeight + 'px';
    }
  }

  function initAll() {
    document.querySelectorAll('.faq-section').forEach(initFaqSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the theme editor re-renders this section
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.faq-section');
    if (section) initFaqSection(section);
  });
})();